import _ from "lodash";
import { SimpleMapper } from "./SimpleMapper";
import { IPartnersTranslation } from "../domain/models/PartnersTranslation";
import { PartnersTranslationDTO } from "../domain/models/dto/PartnersDTO";

export class PartnersTranslationMapper extends SimpleMapper<
    IPartnersTranslation,
    PartnersTranslationDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "title",
        "description",
        "languageCode",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "partnerId",
        "availableLangs",
    ];

    fromDTO(dto: PartnersTranslationDTO): IPartnersTranslation {
        if (!dto) {
            return null;
        }
        const result = super.fromDTO(dto);
        result.languageCode = !_.isEmpty(dto.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }

    toDTO(model: IPartnersTranslation): PartnersTranslationDTO {
        if (!model) {
            return null;
        }
        const result = super.toDTO(model);
        result.languageCode = !_.isEmpty(model.languageCode)
            ? result.languageCode.toLowerCase()
            : null;

        return result;
    }
}
